export default "__VITE_PUBLIC_ASSET__fb2189d1__"